import Cookies from 'js-cookie';
import Modal from 'bootstrap/js/src/modal';

const SEASON_END_COOKIE_KEYS = {
	'DATA'                                : 'SEASON_END_COOKIE',
	'OPENED_EVENTS_WITHOUT_ARRANGEMENTS'  : 'openedEventsWithoutArrangements',
	'SEASON_END_COOKIE_EXPIRATION_IN_DAYS': 365
};

class CustomSeasonEndPopUp {
	constructor() {
		this.hasArrangementBlock = window.CustomSeasonEndPopUp.hasArrangementBlock;

		this.cookieData = this._getCookieData();

		this.init();
	}

	/**
	 * @returns {!Object}
	 * @private
	 */
	_getCookieData() {
		try {
			return JSON.parse(Cookies.get(SEASON_END_COOKIE_KEYS.DATA) || '{}');
		} catch {
			// remove the bad data from the cookies
			Cookies.remove(SEASON_END_COOKIE_KEYS.DATA);
		}

		return {};
	}

	/**
	 * @param {string|number|null} leagueId
	 * @returns {Array}
	 */
	getCustomSeasonEndPopUpIds(leagueId) {
		const rawIds = this.cookieData[leagueId]?.[SEASON_END_COOKIE_KEYS.OPENED_EVENTS_WITHOUT_ARRANGEMENTS];

		return Array.isArray(rawIds) ? rawIds : [];
	}

	/**
	 * @param {number} id
	 * @param {number} leagueId
	 */
	saveCustomSeasonEndPopUpId(id, leagueId) {
		this._saveIdInArrayToCookie(SEASON_END_COOKIE_KEYS.OPENED_EVENTS_WITHOUT_ARRANGEMENTS, id, leagueId);
	}

	/**
	 * @param {number} id
	 * @param {number} leagueId
	 */
	removeCustomSeasonEndPopUpId(id, leagueId) {
		// Only the id will be removed by this
		// this._removeIdFromArrayToCookie(SEASON_END_COOKIE_KEYS.OPENED_EVENTS_WITHOUT_ARRANGEMENTS, id, leagueId);
		
		this._removeLeagueToCookie(leagueId);
	}

	/**
	 * @param {string} 					key
	 * @param {string|number|!Object} 	value
	 * @param {string|number|null} 	    leagueId
	 * @private
	 */
	_saveIdInArrayToCookie(key, value, leagueId) {
		if (!this.cookieData?.[leagueId]) {
			this.cookieData[leagueId] = {};
		}

		let rawValues = this.cookieData[leagueId][key];
		
		if (!Array.isArray(rawValues)) {
			rawValues = [];
		}
		
		rawValues.push(value);

		this._saveCookieData(key, rawValues, leagueId);
	}
	
	/**
	 * @param {string|number|null} 	leagueId
	 * @private
	 */
	_removeLeagueToCookie(leagueId) {
		if (this.cookieData?.[leagueId]) {
			delete this.cookieData[leagueId];
		}
		
		this._saveCookieData(null, null, null, false);
	}
	
	/**
	 * Only the id will be removed by this
	 * @param {string} 				key
	 * @param {string|number|null} 	value
	 * @param {string|number|null} 	leagueId
	 * @param {number|null} 		index
	 * @private
	 */
	_removeIdFromArrayToCookie(key, value, leagueId, index = null) {
		let rawValues = this.cookieData?.[leagueId]?.[key];

		if (Array.isArray(rawValues)) {
			const removeFromIndex = index === null ? rawValues.indexOf(value) : index;

			rawValues.splice(removeFromIndex, 1);
		} else {
			rawValues = [];
		}

		this._saveCookieData(key, rawValues, leagueId);
	}

	/**
	 * @param {string} 	            key
	 * @param {*} 		            value
	 * @param {string|number|null} 	leagueId
	 * @param {boolean}             shouldupdate
	 * @private
	 */
	_saveCookieData(key, value, leagueId, shouldupdate = true) {
		if (shouldupdate) {
			this._updateCookieData(key, value, leagueId);
		}
		
		// console.log('_saveCookieData(): this.cookieData:', JSON.stringify(this.cookieData))
		
		Cookies.set(
			SEASON_END_COOKIE_KEYS.DATA,
			JSON.stringify(this.cookieData),
			{
				'expires': SEASON_END_COOKIE_KEYS.SEASON_END_COOKIE_EXPIRATION_IN_DAYS
			}
		);
	}

	/**
	 * @param {string} 	key
	 * @param {*} 		value
	 * @param {string|number|null} 	leagueId
	 * @private
	 */
	_updateCookieData(key, value, leagueId) {
		const removeKey = !value || (Array.isArray(value) && !value.length);

		if (removeKey) {
			delete this.cookieData[leagueId]?.[key];
		} else {
			if (!Array.isArray(this.cookieData[leagueId])) {
				this.cookieData[leagueId] = {};
			}

			this.cookieData[leagueId][key] = value;
		}
	}

	_controlModals() {
		const isCurrentArrangementEmpty = this.getCustomSeasonEndPopUpIds(window.CustomSeasonEndPopUp.leagueId).includes(window.CustomSeasonEndPopUp.eventId),
		
		 customSeasonEndPopUpModal = document.getElementById('customSeasonEndPopUpModal');

		if (customSeasonEndPopUpModal) {
			Modal
				.getOrCreateInstance(customSeasonEndPopUpModal)
				.show();
		}
		
		if (!isCurrentArrangementEmpty && !this.hasArrangementBlock) {
			if (typeof this.cookieData?.[window.CustomSeasonEndPopUp.leagueId] === 'undefined' && // console.log('SHOW -> END-POP-UP-MODAL')
				customSeasonEndPopUpModal) {
					Modal
						.getOrCreateInstance(customSeasonEndPopUpModal)
						.show();
				}

			this.saveCustomSeasonEndPopUpId(window.CustomSeasonEndPopUp.eventId, window.CustomSeasonEndPopUp.leagueId);
		} else if (this.hasArrangementBlock) {
			// console.log('HIDE -> END-POP-UP-MODAL')
			this.removeCustomSeasonEndPopUpId(window.CustomSeasonEndPopUp.eventId, window.CustomSeasonEndPopUp.leagueId);
		} else {
			  // console.log('Do not do anything')
			  // console.log('HIDE -> END-POP-UP-MODAL')
		}
	}

	init() {
		if (this.hasArrangementBlock) {
			this._controlModals();
		} else {
			import(
				/* webpackChunkName: "modals" */
				'../modals'
			)
			.then(({'default': Modals}) => {
				new Modals();

				this._controlModals();
			});
		}
	}
}

export default CustomSeasonEndPopUp;